import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LoadingIndicatorType = {
    isLoading: boolean;
    isTimeout: boolean;
};

export const hideLoading = createAsyncThunk("loading/hideLoading", async () => {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, 2000);
    });
});

const initialState = {
    isLoading: false,
    isTimeout: false,
} as LoadingIndicatorType;

const LoadingIndicatorSlice = createSlice({
    name: "loading",
    initialState: initialState,
    reducers: {
        toggleLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        resetLoading: (state) => {
            state.isLoading = false;
            state.isTimeout = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(hideLoading.pending, (state) => {
            state.isLoading = true;
            state.isTimeout = false;
        });
        builder.addCase(hideLoading.fulfilled, (state) => {
            state.isTimeout = true;
        });
    },
});

export const { toggleLoading, resetLoading } = LoadingIndicatorSlice.actions;

export default LoadingIndicatorSlice.reducer;
